<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCalculationStore } from '@/stores/calculation'
import { useMaterialStore } from '@/stores/material'

const calculationStore = useCalculationStore()
const materialStore = useMaterialStore()

const { currentItem, writeLoading, updateProjectParamsDialog } = storeToRefs(calculationStore)
const { closeUpdateProjectParamsDialog, updateProjectParams } = calculationStore

const handleUpdateProjectParams = async () => {
  if (!currentItem.value) return
  await updateProjectParams(currentItem.value)
  closeUpdateProjectParamsDialog()

  if (currentItem.value?.material) {
    await materialStore.fetchOptions()
    await materialStore.fetchItem(currentItem.value.material.id)
  }
}

const message = `
  The data (Materials, Cost unit rates) in the current calculation do not match the data at the project level.
  Would you like to <strong>update the calculation</strong> with the new data or keep the original values?
`
</script>

<template>
  <v-dialog
    v-model="updateProjectParamsDialog"
    max-width="600"
    @click:outside="closeUpdateProjectParamsDialog"
  >
    <v-card class="pa-3">
      <v-card-title class="header-font">Data mismatch</v-card-title>
      <v-card-text class="pt-3 pl-4" v-html="message"></v-card-text>
      <slot name="info"></slot>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn
          @click="closeUpdateProjectParamsDialog"
          :disabled="writeLoading"
          class="text-none"
          color="primary"
          variant="text"
        >
          Keep the original data
        </v-btn>
        <v-btn
          @click="handleUpdateProjectParams"
          :loading="writeLoading"
          class="text-none"
          variant="text"
          color="primary"
        >
          Update new data
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped></style>
